import { Grid, Stack } from "@mui/material";
import { Provider } from "react-redux";
import { Outlet } from "react-router";
import ErrorBoundary from "@entrilia/shared/components/ErrorBoundary";
import FullScreenLoader from "@entrilia/shared/components/fullScreenLoader/FullScreenLoader";
import { ReportType } from "../../../../api/types/svTypes.ts";
import useUserContext from "../../../../context/useUserContext.ts";
import { AppInitializer } from "./components/AppInitializer";
import VersionPreviewBar from "./components/builder/version-history/VersionPreviewBar.tsx";
import { ClientContextProvider } from "./contexts/ClientContextProvider";
import { SupportedReportTypesContextProvider } from "./contexts/SupportedReportTypesContextProvider.tsx";
import { useClientManagement } from "./hooks/useClientManagement";
import { store } from "./store/store";
import { getAllReportTypes } from "./utilities/reportTypeHelper.ts";

const defaultSupportedReportTypes = getAllReportTypes().filter((type) => type !== ReportType.Tile);

interface Props {
  supportedReportTypes?: ReportType[];
}

export default function SmartViewAppPage({ supportedReportTypes = defaultSupportedReportTypes }: Props) {
  const { clients } = useUserContext();
  const { clientInfo } = useClientManagement();

  if (clientInfo === undefined) {
    return <FullScreenLoader title="Please wait" subtitle="Loading user's data..." />;
  }

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <AppInitializer>
          <ClientContextProvider
            client={{
              clientInfo: clientInfo,
              clients: clients,
            }}
          >
            <SupportedReportTypesContextProvider supportedReportTypes={supportedReportTypes}>
              <Stack sx={{ flex: 1 }}>
                <Grid container sx={{ flex: 1, maxHeight: "100%", width: "100%" }}>
                  <Outlet />
                  <VersionPreviewBar />
                </Grid>
              </Stack>
            </SupportedReportTypesContextProvider>
          </ClientContextProvider>
        </AppInitializer>
      </Provider>
    </ErrorBoundary>
  );
}
